import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./../Pages/Home";
import AboutUs from "./../Pages/AboutUs";
// import TermsAndConditions from "./../Pages/TermsAndConditions";
import PrivacyPolicy from "./../Pages/PrivacyPolicy";
import Page404 from "../Pages/Page404";
import LayoutWithNavAndFooter from "../Layouts/LayoutWithNavAndFooter";
import ContactUs from "../Pages/ContactUs";

const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<LayoutWithNavAndFooter />}>
        <Route index element={<Navigate to={"/home"} />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        {/* <Route path="/terms-and-conditions" element={<TermsAndConditions />} /> */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} />
      </Route>
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default AppRoutes;
